import posthog from 'posthog-js'
import { isPosthogEnabled, posthogKey, posthogHost } from './env'

export function initPosthog(): void {
  if (!isPosthogEnabled) return

  posthog.init(posthogKey, {
    api_host: posthogHost,
    capture_pageview: false,
    capture_pageleave: true,
    persistence: 'localStorage',
    autocapture: false,
    advanced_disable_feature_flags: true,
  })

  posthog.register({
    app_version: __APP_VERSION__,
    build_id: __BUILD_ID__,
  })
}

export function identifyPosthogUser(userId: string): void {
  if (!isPosthogEnabled) return
  posthog.identify(userId)
}

export function track(event: string, properties?: Record<string, unknown>): void {
  if (!isPosthogEnabled) return
  try {
    posthog.capture(event, properties)
  } catch (e) {
    console.warn('PostHog track failed:', e)
  }
}

export function trackSecurity(event: string, properties?: Record<string, unknown>): void {
  track(`security_${event}`, { category: 'security', ...properties })
}

export function resetPosthog(): void {
  if (!isPosthogEnabled) return
  posthog.reset()
}
